export enum FyldScreen {
  INSIGHTS = 'Insights',
  FATIGUE_MANAGER = 'Fatigue Manager',
  JOBS = 'Jobs',
}
